import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-35b0a4f0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "project-info render-hide-scroll"
};
const _hoisted_2 = {
  class: "failed-info"
};
const _hoisted_3 = {
  key: 0,
  class: "failed-more"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看更新", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/icon/project_right_more.png"
}, null, -1));
const _hoisted_6 = [_hoisted_4, _hoisted_5];
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  key: 2,
  class: "project-success"
};
const _hoisted_9 = {
  class: "success-time"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/icon/success2x.png"
}, null, -1));
const _hoisted_11 = {
  class: "project-title"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "project-title-logo render-line-clamp",
  src: "https://p6.moimg.net/md/icon/project_title_icon@2x.png"
}, null, -1));
const _hoisted_13 = {
  class: "project-type-address-bullish"
};
const _hoisted_14 = {
  key: 0,
  class: "item pro-type"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://p6.moimg.net/md/icon/project_type_icon@2x.png"
}, null, -1));
const _hoisted_16 = {
  key: 1,
  class: "item pro-address"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://p6.moimg.net/md/icon/project_address_icon@2x.png"
}, null, -1));
const _hoisted_18 = {
  class: "rank_title"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "https://p6.moimg.net/mdwxapp/rank/detail_rank_icon.png"
}, null, -1));
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  key: 4,
  class: "agrement"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "风险提示", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 3. 如果您发现某个项目涉嫌违规，欢迎在APP中点击项目右上角进行举报，我们会在第一时间处理，感谢您和我们一起建设摩点社区。 ", -1));
const _hoisted_24 = {
  key: 5,
  class: "goal-unlock"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("text", null, "解锁福利"), /*#__PURE__*/_createElementVNode("text", {
  class: "more"
}, "查看更多"), /*#__PURE__*/_createElementVNode("img", {
  class: "more_icon",
  src: "https://p6.moimg.net/md/icon/project_right_more.png",
  mode: "heightFix"
})], -1));
const _hoisted_26 = {
  class: "goal-unlock-list-left"
};
const _hoisted_27 = {
  key: 0,
  class: "goal_icon_status",
  src: "https://p6.moimg.net/md/icon/pro_goal_unlock_done.png"
};
const _hoisted_28 = {
  key: 1
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "goal_icon_status",
  src: "https://p6.moimg.net/md/icon/pro_goal_unlock_ing.png"
}, null, -1));
const _hoisted_30 = {
  class: "goal_icon_status"
};
const _hoisted_31 = {
  key: 2,
  class: "goal_icon_status goal_icon_circle"
};
const _hoisted_32 = {
  class: "goal-unlock-right"
};
const _hoisted_33 = {
  class: "goal-unlock-right-info"
};
const _hoisted_34 = {
  class: "goal_info"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "目标", -1));
const _hoisted_36 = {
  class: "goal_money"
};
const _hoisted_37 = {
  class: "goal-title"
};
const _hoisted_38 = {
  key: 0,
  class: "goal-unlock-tips"
};
const _hoisted_39 = {
  class: "des"
};
const _hoisted_40 = {
  key: 6,
  class: "draw-new-box"
};
const _hoisted_41 = {
  key: 7,
  class: "project-update"
};
const _hoisted_42 = {
  class: "left-tit"
};
const _hoisted_43 = {
  class: "num"
};
const _hoisted_44 = {
  key: 0,
  src: "https://p6.moimg.net/mdwxapp/update_activity.png"
};
const _hoisted_45 = {
  key: 1,
  src: "https://p6.moimg.net/mdwxapp/update_activity_help.png"
};
const _hoisted_46 = {
  class: "time"
};
const _hoisted_47 = {
  class: "left-info"
};
const _hoisted_48 = {
  class: "name render-line-clamp"
};
const _hoisted_49 = ["src"];
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "历史更新", -1));
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/icon/update_history.png"
}, null, -1));
const _hoisted_52 = [_hoisted_50, _hoisted_51];
const _hoisted_53 = {
  ref: "editorBox"
};
const _hoisted_54 = {
  key: 0,
  class: "risk-info"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "risk-info-tit"
}, "发货与售后", -1));
const _hoisted_56 = {
  class: "risk-info-cont"
};
const _hoisted_57 = {
  key: 1,
  class: "risk-info-3c"
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "3C认证证书", -1));
const _hoisted_59 = {
  key: 1,
  class: "risk-info urgent_notices"
};
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "risk-info-tit"
}, "温馨提示", -1));
const _hoisted_61 = ["src"];
const _hoisted_62 = {
  key: 3,
  class: "common-question"
};
const _hoisted_63 = {
  class: "title"
};
const _hoisted_64 = {
  class: "tit"
};
const _hoisted_65 = {
  key: 4,
  class: "teamfund-box"
};
const _hoisted_66 = {
  class: "title"
};
const _hoisted_67 = {
  class: "tit"
};
const _hoisted_68 = /*#__PURE__*/_createTextVNode("一起筹");
const _hoisted_69 = {
  key: 5,
  class: "content-fold-overlay"
};
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-fold-gradient"
}, null, -1));
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "content-fold-text"
}, "点击查看更多", -1));
const _hoisted_72 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "content-fold-arrow",
  src: "https://p6.moimg.net/md/icon/project_bottom_more.png"
}, null, -1));
const _hoisted_73 = [_hoisted_71, _hoisted_72];
const _hoisted_74 = {
  key: 8,
  class: "send-project-box"
};
const _hoisted_75 = {
  class: "send-project"
};
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/icon/idea-2x.png"
}, null, -1));
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, [/*#__PURE__*/_createElementVNode("strong", null, "我也有好想法！"), /*#__PURE__*/_createElementVNode("span", null, "点此立即发起众筹")], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Error = _resolveComponent("Error");
  const _component_CompHeader = _resolveComponent("CompHeader");
  const _component_CompTopSwiper = _resolveComponent("CompTopSwiper");
  const _component_CompStatus = _resolveComponent("CompStatus");
  const _component_CompLottieAnimation = _resolveComponent("CompLottieAnimation");
  const _component_van_image = _resolveComponent("van-image");
  const _component_DrawNew = _resolveComponent("DrawNew");
  const _component_CompProphet = _resolveComponent("CompProphet");
  const _component_CompInitiator = _resolveComponent("CompInitiator");
  const _component_CompAgreement = _resolveComponent("CompAgreement");
  const _component_DoubleCols = _resolveComponent("DoubleCols");
  const _component_CompBottomBtn = _resolveComponent("CompBottomBtn");
  const _component_CompPopupFavor = _resolveComponent("CompPopupFavor");
  const _component_CompGoalsUnlock = _resolveComponent("CompGoalsUnlock");
  return $data.showError ? (_openBlock(), _createBlock(_component_Error, {
    key: 0,
    message: $data.showMessage
  }, null, 8, ["message"])) : !$data.ideaLoading ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_CompHeader, {
    ref: "compHeader",
    name: $data.product_info.title,
    hide_back: _ctx.$route.query.fromApp === 'hejiaqin'
  }, null, 8, ["name", "hide_back"]), _createVNode(_component_CompTopSwiper, {
    product_info: $data.product_info
  }, null, 8, ["product_info"]), $options.pro_failed ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "project-failed",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goUpdateList && $options.goUpdateList(...args))
  }, [_createElementVNode("div", _hoisted_2, _toDisplayString($data.product_info.status_desc), 1), $data.product_info.status_code == 6 || $data.product_info.status_code == 7 || $data.product_info.status_code == 8 ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.product_info.warning_txt ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "project-warning",
    innerHTML: $data.product_info.warning_txt
  }, null, 8, _hoisted_7)) : _createCommentVNode("", true), $data.product_info.status_code == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString($data.product_info.status_desc), 1), _hoisted_10])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createTextVNode(" " + _toDisplayString($data.product_info.title), 1)]), _createElementVNode("div", _hoisted_13, [$options.show_category ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_hoisted_15, _createElementVNode("span", null, _toDisplayString($data.product_info.category), 1)])) : _createCommentVNode("", true), $data.product_info.province ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_hoisted_17, _createElementVNode("span", null, _toDisplayString($data.product_info.province) + "·" + _toDisplayString($data.product_info.city), 1)])) : _createCommentVNode("", true), $data.rank_info && $data.rank_info.rank_tag_name ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "item rank_info",
    onClick: _cache[1] || (_cache[1] = _withModifiers($event => $options.goCategoryList($data.rank_info), ["stop"]))
  }, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createTextVNode(" " + _toDisplayString($data.rank_info.rank_tag_name), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "item pro-bullish",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.onFavor && $options.onFavor(...args))
  }, [_createElementVNode("img", {
    class: "icon",
    src: `${$data.product_info.if_favor ? 'https://p6.moimg.net/md/icon/bullish_true@2x.png' : 'https://p6.moimg.net/md/icon/bullish_flase@2x.png'}`
  }, null, 8, _hoisted_20), _createElementVNode("span", {
    class: _normalizeClass(['text', {
      color: $data.product_info.if_favor
    }])
  }, _toDisplayString($options.formatFavorCount($data.product_info.favor_count)) + "人看好", 3)])]), $data.product_info.status_code != 4 && !$data.loading && $data.product_info.pro_class != '102' ? (_openBlock(), _createBlock(_component_CompStatus, {
    key: 3,
    product_info: $data.product_info,
    onGetInfoRt: $options.getProjectInfoTR
  }, null, 8, ["product_info", "onGetInfoRt"])) : _createCommentVNode("", true), $data.product_info.pro_class == 201 ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_hoisted_22, _createElementVNode("p", null, " 1. " + _toDisplayString($data.product_info.category) + "项目是摩点为发起人提供的社交圈筹款工具，摩点仅提供平台功能和技术服务，不监管发起人的回报发放等情况，项目可能存在风险，摩点提醒您了解项目后再支持； ", 1), _createElementVNode("p", null, " 2. 您对" + _toDisplayString($data.product_info.category) + "项目完成付款后，无法申请退款，除非发起人发起项目的批量退款。 ", 1), _hoisted_23])) : _createCommentVNode("", true), $data.goalUnlockListShow && $data.goalUnlockListShow.length ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", {
    onClick: _cache[3] || (_cache[3] = (...args) => $options.showUnlockGoalAction && $options.showUnlockGoalAction(...args))
  }, [_hoisted_25, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.goalUnlockListShow, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "goal-unlock-list"
    }, [_createElementVNode("div", _hoisted_26, [item.status == 200 ? (_openBlock(), _createElementBlock("img", _hoisted_27)) : $options.getIng(item) ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_hoisted_29, _createElementVNode("div", _hoisted_30, [_createVNode(_component_CompLottieAnimation, {
      jsonUrl: "https://p6.moimg.net/mdwxapp/lottie_json/project_info_goals_unlock_jiesuo.json",
      loop: true
    })])])) : (_openBlock(), _createElementBlock("div", _hoisted_31))]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_hoisted_35, _createElementVNode("span", _hoisted_36, "¥" + _toDisplayString($options.fNum(item.amount)), 1), item.status == 200 || item.status == 300 || $options.getIng(item) ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: _normalizeClass(['goal_text_status', {
        'goal_text_status_true': item.status == 200
      }, {
        'goal_text_status_false': item.status == 100 || item.status == 300
      }])
    }, _toDisplayString($data.statusMap[item.status]), 3)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_37, "解锁后获得" + _toDisplayString(item.prizes.length) + "项福利", 1)]), _createVNode(_component_van_image, {
      class: "goal_prizes_item_img",
      src: _ctx.$imgUrlFilter(item.prizes[0].img, 68),
      fit: "cover"
    }, null, 8, ["src"])])]);
  }), 128))]), $data.showUnlockGoalTips ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, _toDisplayString($data.unlockGoalTipsItem.desc), 1), _createElementVNode("div", {
    class: "btn",
    onClick: _cache[4] || (_cache[4] = $event => $options.taskAction())
  }, _toDisplayString($data.conditionsBtnMap[$data.unlockGoalTipsItem.type]), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.pro_draw_list && $data.pro_draw_list.length ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createVNode(_component_DrawNew, {
    drawInfo: $data.pro_draw_list[0]
  }, null, 8, ["drawInfo"])])) : _createCommentVNode("", true), $data.update_info.num ? (_openBlock(), _createElementBlock("div", _hoisted_41, [_createElementVNode("div", {
    class: "project-update-left",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.goUpdateInfo && $options.goUpdateInfo(...args))
  }, [_createElementVNode("div", _hoisted_42, [_createElementVNode("span", _hoisted_43, [_createTextVNode(_toDisplayString($data.update_info.num) + " ", 1), $data.update_info.type == 2 ? (_openBlock(), _createElementBlock("img", _hoisted_44)) : $data.update_info.type == 3 ? (_openBlock(), _createElementBlock("img", _hoisted_45)) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_46, _toDisplayString($data.update_info.ctime), 1)]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, _toDisplayString($data.update_info.title), 1), _createElementVNode("img", {
    src: `${_ctx.$imgUrlFilter($data.update_info.logo, 412)}`
  }, null, 8, _hoisted_49)])]), _createElementVNode("div", {
    class: "project-update-right",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.goUpdateList && $options.goUpdateList(...args))
  }, _hoisted_52)])) : _createCommentVNode("", true), _createVNode(_component_CompProphet, {
    pro_id: $data.pro_id
  }, null, 8, ["pro_id"]), _createVNode(_component_CompInitiator, {
    product_info: $data.product_info,
    user_info: $data.user_info
  }, null, 8, ["product_info", "user_info"]), _createElementVNode("div", {
    class: _normalizeClass(["foldable-content-container", {
      'content-folded': $data.content_fold && !$data.isContentExpanded
    }])
  }, [_createElementVNode("div", _hoisted_53, null, 512), $data.product_info.risk || $data.product_info.certificate_ccc_id ? (_openBlock(), _createElementBlock("div", _hoisted_54, [$data.product_info.risk ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_55, _createElementVNode("div", _hoisted_56, _toDisplayString($data.product_info.risk), 1)], 64)) : _createCommentVNode("", true), $data.product_info.certificate_ccc_id ? (_openBlock(), _createElementBlock("div", _hoisted_57, [_hoisted_58, _createElementVNode("div", {
    class: "click-div",
    onClick: _cache[7] || (_cache[7] = (...args) => $options.showCertificateCcc && $options.showCertificateCcc(...args))
  }, "点击查看")])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.product_info.urgent_notices ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_hoisted_60, _createElementVNode("div", null, _toDisplayString($data.product_info.urgent_notices), 1)])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "favor-box",
    onClick: _cache[8] || (_cache[8] = (...args) => $options.onFavor && $options.onFavor(...args))
  }, [_createElementVNode("img", {
    class: "icon",
    src: $data.product_info.if_favor ? 'https://p6.moimg.net/md/icon/bullish_true_new@2x.png' : 'https://p6.moimg.net/md/icon/bullish_false@2x.png'
  }, null, 8, _hoisted_61), _createElementVNode("div", {
    class: _normalizeClass({
      'color': $data.product_info.if_favor
    })
  }, _toDisplayString($data.product_info.if_favor ? '已看好，有新进展会及时通知你' : '戳"看好"关注当前项目'), 3)]), $data.product_info.status_code != 4 && $data.product_info.pro_class != 201 ? (_openBlock(), _createBlock(_component_CompAgreement, {
    key: 2,
    pro_class: $data.product_info.pro_class
  }, null, 8, ["pro_class"])) : _createCommentVNode("", true), $data.question_total > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_createElementVNode("span", _hoisted_64, "常见问题（" + _toDisplayString($data.question_total) + "）", 1), _createElementVNode("span", {
    class: "more",
    onClick: _cache[9] || (_cache[9] = (...args) => $options.goQuestionList && $options.goQuestionList(...args))
  }, "查看更多")]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.question_list, (item, index) => {
    return _openBlock(), _createElementBlock(_Fragment, {
      key: index
    }, [index < 2 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "list",
      onClick: _cache[10] || (_cache[10] = (...args) => $options.goQuestionList && $options.goQuestionList(...args))
    }, _toDisplayString(item.question), 1)) : _createCommentVNode("", true)], 64);
  }), 128))])) : _createCommentVNode("", true), $data.product_info.status_code != 4 && $data.product_info.status_code != 1 && !$options.is_preview ? (_openBlock(), _createElementBlock("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("span", _hoisted_67, [_hoisted_68, $data.teamfund_total ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createTextVNode("（" + _toDisplayString($data.teamfund_total) + "）", 1)], 64)) : _createCommentVNode("", true)]), _createElementVNode("span", {
    class: "more",
    onClick: _cache[11] || (_cache[11] = (...args) => $options.goTeamfund && $options.goTeamfund(...args))
  }, _toDisplayString($data.teamfund_total > 0 ? "查看榜单" : "发起"), 1)])])) : _createCommentVNode("", true), $data.content_fold && !$data.isContentExpanded ? (_openBlock(), _createElementBlock("div", _hoisted_69, [_hoisted_70, _createElementVNode("div", {
    class: "content-fold-expand-btn",
    onClick: _cache[12] || (_cache[12] = (...args) => $options.expandContent && $options.expandContent(...args))
  }, _hoisted_73)])) : _createCommentVNode("", true)], 2), $data.showSendPro ? (_openBlock(), _createElementBlock("div", _hoisted_74, [_createElementVNode("div", _hoisted_75, [_hoisted_76, _hoisted_77, _createElementVNode("div", {
    class: "btn",
    onClick: _cache[13] || (_cache[13] = (...args) => $options.copySendProLink && $options.copySendProLink(...args)),
    id: "copycode",
    "data-clipboard-text": "https://account.modian.com/initiate/"
  }, " 发起众筹 "), _createElementVNode("i", {
    class: "close",
    onClick: _cache[14] || (_cache[14] = (...args) => $options.closeSendPro && $options.closeSendPro(...args))
  })])])) : _createCommentVNode("", true), _createVNode(_component_DoubleCols, {
    ad_position: 'pro_cate_specific_recommend',
    params_string: JSON.stringify({
      page_pro_ids: $data.pro_id
    }),
    title: '为你推荐'
  }, null, 8, ["params_string"]), $data.app_guide ? (_openBlock(), _createElementBlock("div", {
    key: 9,
    class: "project-open-btn",
    onClick: _cache[15] || (_cache[15] = (...args) => $options.goToApp && $options.goToApp(...args))
  }, "打开APP查看更多")) : _createCommentVNode("", true), _createVNode(_component_CompBottomBtn, {
    ref: "compBottomBtn",
    product_info: $data.product_info,
    mina_focus: $data.mina_focus,
    app_guide: $data.app_guide,
    onGetWxScheme: $options.getWxScheme,
    onOnFavor: $options.onFavor
  }, null, 8, ["product_info", "mina_focus", "app_guide", "onGetWxScheme", "onOnFavor"]), _createVNode(_component_CompPopupFavor, {
    show: $data.showFavor,
    "onUpdate:show": _cache[16] || (_cache[16] = $event => $data.showFavor = $event),
    type: $data.favorType,
    onCancelFavor: $options.cancelFavor
  }, null, 8, ["show", "type", "onCancelFavor"]), _createVNode(_component_CompGoalsUnlock, {
    show: $data.showUnlockGoal,
    "onUpdate:show": _cache[17] || (_cache[17] = $event => $data.showUnlockGoal = $event),
    pro_id: $data.product_info.id,
    goalUnlockList: $data.goalUnlockList,
    giveaway_type: $data.giveaway_type
  }, null, 8, ["show", "pro_id", "goalUnlockList", "giveaway_type"])])) : _createCommentVNode("", true);
}